/** Past this many options a list is faster to search than to scan. */
const SEARCH_THRESHOLD = 8;

/** Whether a `DimeFilterList` shows its search box: `always`, `never`, or (`auto`) once its options are searched server-side or outnumber a quick scan. */
export function filterListShowsSearch({
  search = 'auto',
  serverSearched,
  optionCount,
}: Readonly<{
  search?: 'auto' | 'always' | 'never';
  serverSearched: boolean;
  optionCount: number;
}>): boolean {
  if (search !== 'auto') return search === 'always';
  return serverSearched || optionCount > SEARCH_THRESHOLD;
}
